import { schema } from 'normalizr';

const productCategorySchema = new schema.Entity('productCategories', {});

export default productCategorySchema;
